/**
 * Custom checkout — manipulacja sekcją "Sposób płatności".
 *
 * Toggle `.is-selected` na klikniętym `.hn-co__payment-card` + show/hide
 * `.payment_box` (pola gateway'a, np. inputy karty pod "Karta · Apple/Google Pay").
 *
 * Klasa `.is-selected` jest renderowana serwerowo z `chosen_payment_method`
 * w sesji — bez tego handlera klik na innym radio nie zmienia podświetlenia
 * (border zostaje na starym wyborze), bo nic nie aktualizuje DOM.
 *
 * WC core checkout.js bindiuje `change` na `input[name="payment_method"]`,
 * ale firuje swój `payment_method_selected` event tylko gdy radio jest w
 * `form.checkout` Z PRAWIDŁOWĄ inicjalizacją — nasz custom layout bywa
 * niezbindowany na czas (Perfmatters delay / FunnelKit interferencje).
 * Robimy własny handler, niezależny.
 */
export function initCheckoutPayment() {
    // Initial section detection — checkout (`/do-kasy/`) lub order-pay (`/do-kasy/zamowienie-platnosc/`).
    const section = document.querySelector('[data-hn-co-section="payment"]') || document.querySelector('.hn-co__payment-list') || document.querySelector('.hn-pay__methods');
    if (!section) return;

    // Trigger WC `payment_method_selected` event jeśli jQuery jest — pluginy
    // typu WooPayments / Stripe re-mountują pola na ten event.
    const notifyWc = () => {
        if (window.jQuery) {
            window.jQuery(document.body).trigger('payment_method_selected');
        }
    };

    document.addEventListener('change', (e) => {
        const radio = e.target;
        if (!radio || !radio.matches('input[name="payment_method"]')) return;

        const list = radio.closest('.hn-co__payment-list, .hn-pay__methods, .payment_methods');
        if (!list) return;

        // Reset .is-selected na wszystkich kartach + hide ich payment_box.
        // Selector pokrywa both layouts: main checkout (.hn-co__payment-card) i order-pay (.hn-pay__method).
        list.querySelectorAll('.hn-co__payment-card, .hn-pay__method').forEach((card) => {
            card.classList.remove('is-selected');
            const box = card.querySelector('.payment_box');
            if (box) box.style.display = 'none';
        });

        // Aktywna karta.
        const card = radio.closest('.hn-co__payment-card, .hn-pay__method');
        if (card) {
            card.classList.add('is-selected');
            const box = card.querySelector('.payment_box');
            if (box) box.style.display = '';
        }

        notifyWc();
    });
}
